
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayDigitalClosed as ObiTwowayDigitalClosedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-digital-closed.js';
 
 
 

 
 export const ObiTwowayDigitalClosed = createComponent({
   react: React,
   tagName: 'obi-twoway-digital-closed',
   elementClass: ObiTwowayDigitalClosedElement,
   events: {
     
   }
  });
 
 